// extracted by mini-css-extract-plugin
module.exports =  {"negativeChip":"OvnozvQ1h6pKHlTkUoc2"};